module.exports = __webpack_public_path__ + "static/media/RGN2_220.3b117b18.png";